import { type SxProps, useTheme } from '@chronosphereio/chrono-ui';

/**
 * Inline "Edit with AI" styling for {@link AIEditButton}.
 * Legacy Prometheus / logs assistant buttons keep their own styles until migration.
 */
export function useEditWithAIButtonSx(): SxProps {
  const { theme } = useTheme();
  return {
    flexShrink: 0,
    px: 1,
    whiteSpace: 'nowrap',
    color: 'text.secondary',
    bgcolor:
      !theme.featureFlags.panwRebrandStubYear && theme.palette.mode === 'light'
        ? theme.palette.grey[50]
        : theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
    '&:hover': {
      color: 'text.primary',
      bgcolor:
        !theme.featureFlags.panwRebrandStubYear && theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.action.hover,
      border: `1px solid ${theme.palette.divider}`,
    },
  };
}
